<template>
  <div id="contenedor-agregar-contrato-asunto">
    <v-card>
      <v-card-title class="secondary--text">
        Editar asunto
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
          <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="formularioValido" ref="actualizarContratoAsunto">
          <v-row>
            <v-col cols="12">
              <custom-autocomplete
                v-model="asunto.idSubTema"
                label="Seleccionar Sub Tema"
                :items="getContratoSubTemas"
                itemText="descripcion"
                itemValue="id"
                clearable
              >
              </custom-autocomplete>
            </v-col>
            <v-col cols="12">
              <text-field v-model="asunto.numero" label="Número"> </text-field>
            </v-col>
            <v-col cols="12">
              <TextArea v-model="asunto.descripcion" label="Descripción" rows="2"> </TextArea>
            </v-col>
            <v-col cols="12">
              <TextArea v-model="asunto.responsables" label="Responsables" rows="2"> </TextArea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixActualizarAsunto"
          :disabled="!formularioValido || enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Actualizar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CONTRATO_SUB_TEMAS from '@/graphql/querys/administracion/contratos/contrato/subtemas/contratoSubTemas.gql';
import mixContratoAsuntos from './mixContratoAsuntos';
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import TextField from '@/components/inputs/TextField.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarContratoAsunto',
  mixins: [mixContratoAsuntos],
  components: {
    TextArea,
    CustomAutocomplete,
    CustomButton,
    TextField,
  },
  props: {
    contratoAsuntoEditar: {
      type: Object,
      required: true,
    },
  },
  apollo: {
    contratoSubTemas: {
      query: CONTRATO_SUB_TEMAS,
      variables() {
        return {
          idTema: this.contratoAsuntoEditar.subTema.idTema,
        };
      },
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      formularioValido: false,
      asunto: {
        idSubTema: this.contratoAsuntoEditar.idSubTema,
        numero: this.contratoAsuntoEditar.numero,
        descripcion: this.contratoAsuntoEditar.descripcion,
        responsables: this.contratoAsuntoEditar.responsables,
      },
    };
  },
  methods: {
    cerrar() {
      this.$refs.actualizarContratoAsunto.reset();
      this.$emit('cerrar');
    },
  },
  computed: {
    getContratoSubTemas() {
      if (!this.contratoSubTemas) return [];
      return this.contratoSubTemas;
    },
  },
};
</script>

<style lang="scss"></style>
